import { types } from 'mobx-state-tree'

const TrafficQuote = types.model('TrafficQuote', {
  id: types.identifier,
  objectId: types.string,
  name: types.string,
  companyName: types.string,
  summary: types.string,
  avatarUrl: types.maybeNull(types.string),
  letterHeaderUrl: types.maybeNull(types.string),
  bannerUrl: types.maybeNull(types.string),
  videoUrl: types.maybeNull(types.string),
  videoThumbnailUrl: types.maybeNull(types.string),
  pricing: types.frozen({
    // winItPrice: types.number,
    // basePrice: types.number,
    // attorneyPrice: types.number
  }),
  meta: types.frozen({
    // summary: types.string,
    // details: types.string,
    // name: types.string,
    // title: types.string,
    // companyName: types.string,
    // secondaryCompanyName: types.string,
    // address: types.array(types.string),
    // contact: types.array(types.string)
  }),
  faq: types.array(types.array(types.string))
})

export default TrafficQuote
